// Colours for the dashboard's data visualisations, read off the theme.
//
// Series colours come from the design system's categorical graph ramp
// (`sys.color.graph.*`) — the ramp that exists for exactly this purpose. The PRD
// (§6.4) describes the Sky rendering: graph/1 is Sky's blue and graph/8 its red, so
// created reads blue and SLA-breached reads red as specified, while graph/7 gives
// resolved a distinct green-teal. A Sage customer gets Sage's hues for the same
// indices; that re-hueing is the point of a themed ramp, and is why these are token
// lookups rather than the literal blue/green/red the PRD names.
//
// Only the slice of the token tree these charts read is declared, rather than
// depending on the design system's full theme type (which is unavailable when the
// package resolves to a stub) — same approach as PriorityBadge's FlagColorTokens.
export interface GraphColorTokens {
	sys?: {color?: {graph?: Record<string, string>}};
}

export interface TrendSeriesColors {
	created?: string;
	resolved?: string;
	breached?: string;
}

/** Series colours for the tickets created / resolved / breached trend chart. */
export function trendSeriesColors(theme: GraphColorTokens): TrendSeriesColors {
	const graph = theme?.sys?.color?.graph;
	return {
		created: graph?.['1'],
		resolved: graph?.['7'],
		breached: graph?.['8'],
	};
}

/**
 * Fill for the SLA achievement gauge's arc — the ramp's primary series colour, so the
 * gauge and the trend chart's leading series read as one visualisation row.
 */
export function gaugeArcColor(theme: GraphColorTokens): string | undefined {
	return theme?.sys?.color?.graph?.['1'];
}
